import React from "react";
import Header from "../../components/shared/header/index";
import Sidebar from "../../components/shared/sidebar/index";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { RootState } from "../../store/store";
import { logo } from "../../constants/images";
import { Alert, Button } from "antd";
import superAdminService from "../../services/super-admin/super-admin.service";
import { useSelector as useReduxSelector } from "react-redux";
import { RootState as ReduxRootState } from "../../store/store";
import { all_routes } from "../../router/all_routes";
import AppTour from "../shared/tour/AppTour";
import SetupTodo from "../shared/setupTodo/SetupTodo";
import { RolesEnum } from "../../types/route.types";
const Feature = () => {
  const [showLoader, setShowLoader] = useState(true);
  const navigate = useNavigate();
  const { sub, user } = useSelector((state: RootState) => state.auth);
  const headerCollapse = useSelector(
    (state: RootState) => state.theme.headerCollapse
  );
  const mobileSidebar = useSelector(
    (state: RootState) => state.sidebar.mobileSidebar
  );
  const miniSidebar = useSelector(
    (state: RootState) => state.sidebar.miniSidebar
  );
  const expandMenu = useSelector(
    (state: RootState) => state.sidebar.expandMenu
  );
  const dataWidth = useSelector((state: RootState) => state.theme.dataWidth);
  const dataLayout = useSelector((state: RootState) => state.theme.dataLayout);
  const dataLoader = useSelector((state: RootState) => state.theme.dataLoader);

  const dataTheme = useSelector((state: RootState) => state.theme.dataTheme);
  const dataSidebarAll = useSelector(
    (state: RootState) => state.theme.dataSidebarAll
  );
  const dataColorAll = useSelector(
    (state: RootState) => state.theme.dataColorAll
  );

  const dataTopBarColorAll = useSelector(
    (state: RootState) => state.theme.dataTopBarColorAll
  );
  const dataTopbarAll = useSelector(
    (state: RootState) => state.theme.dataTopbarAll
  );
  const location = useLocation();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dataTheme);
  }, [dataTheme]);

  useEffect(() => {
    if (dataLoader === "enable") {
      // Show the loader when navigating to a new route
      setShowLoader(true);

      // Hide the loader after 2 seconds
      const timeoutId = setTimeout(() => {
        setShowLoader(false);
      }, 0);

      return () => {
        clearTimeout(timeoutId); // Clear the timeout when component unmounts
      };
    } else {
      setShowLoader(false);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, dataLoader]);

  const Preloader = () => {
    return (
      <div id="global-loader">
       <div className="page-loader">
        <img src={logo} alt="Loading"/>
      </div>
      </div>
    );
  };

  const isImpersonating = (() => {
    try {
      const originalToken = localStorage.getItem('originalToken');
      const originalUser = localStorage.getItem('originalUser');
      return Boolean(originalToken && originalUser);
    } catch (e) {
      return false;
    }
  })();

  const handleReturnToSuperAdmin = async () => {
    try {
      // Backend varsa stop ucu çağrılır (opsiyonel)
      await superAdminService.stopImpersonation();
    } catch {}
    // Orijinal token ve user'a geri dön
    const originalToken = localStorage.getItem('originalToken');
    const originalUser = localStorage.getItem('originalUser');
    const returnUrl = localStorage.getItem('originalReturnUrl') || '/super-admin/dashboard';

    if (originalToken && originalUser) {
      localStorage.setItem('token', originalToken);
      localStorage.setItem('user', originalUser);
      localStorage.removeItem('originalToken');
      localStorage.removeItem('originalUser');
      localStorage.removeItem('originalReturnUrl');
      window.location.assign(returnUrl);
      return;
    }
    // Fallback: super admin dashboard
    window.location.assign('/super-admin/dashboard');
  };

  useEffect(() => {
    const loader = () => {
      setTimeout(() => {
        setShowLoader(false);
      }, 3000);
    };
    loader();
  }, []);

  return (
    <>
      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
    `}
      </style>
      <div
        className={`
        ${dataLayout === "mini" || dataWidth === "box" ? "mini-sidebar" : ""}
        ${
          dataLayout === "horizontal" ||
          dataLayout === "horizontal-single" ||
          dataLayout === "horizontal-overlay" ||
          dataLayout === "horizontal-box"
            ? "menu-horizontal"
            : ""
        }
       ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
       ${dataWidth === "box" ? "layout-box-mode" : ""} ${
          headerCollapse ? "header-collapse" : ""
        }
      ${
        (expandMenu && miniSidebar) || (expandMenu && dataLayout === "mini")
          ? "expand-menu"
          : ""
      }
       `}
      >
        <>
          {showLoader ? (
            <>
              <Preloader />
              {isImpersonating && (
                <div
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1100,
                    background: '#fde68a',
                    color: '#111827',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px 12px',
                    borderBottom: '1px solid #fbbf24'
                  }}
                >
                  <span style={{ fontWeight: 600 }}>
                    Şu an bir şirket admini adına oturumdasınız
                  </span>
                  <Button size="small" onClick={handleReturnToSuperAdmin}>
                    Süper Admin’e Dön
                  </Button>
                </div>
              )}

              <div
                className={`main-wrapper ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <Header />
                <Sidebar />
                {/* <HorizontalSidebar />
                <TwoColumnSidebar />
                <StackedSidebar /> */}
                {/* <Outlet /> */}
                {/* <DeleteModal /> */}
              </div>
            </>
          ) : (
            <>
              <div
                className={`main-wrapper ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <Header />
                {/* {theme.dataLayout === "horizontal" ? (
                  <HorizontalSidebar />
                ) : theme.dataLayout === "two-column" ? (
                  <TwoColumnSidebar />
                ) : theme.dataLayout === "stacked" ? (
                  <StackedSidebar />
                ) : ( */}
                  <Sidebar />
                {/* // )} */}
                
                {/* 🚨 GRACE PERIOD ALERT - Ödeme gecikme uyarısı */}
                {sub?.status === 'in_grace_period' && (
                  <Alert
                    message={`⚠️ Ödeme Hatırlatması - ${sub.daysLeft} gün kaldı`}
                    description={`${sub.daysLeft} gün sonra hesabınız askıya alınacak. Lütfen ödemenizi yapın.`}
                    type="warning"
                    showIcon
                    closable
                    action={
                      <Button 
                        size="small" 
                        danger 
                        onClick={() => navigate(all_routes.companySettings + '?tab=grace-period-payment')}
                        style={{ fontWeight: 600 }}
                      >
                        Ödeme Yap
                      </Button>
                    }
                    style={{ 
                      margin: '16px 16px 0 16px', 
                      position: 'sticky', 
                      top: 0, 
                      zIndex: 1000,
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                    }}
                  />
                )}
                
                <Outlet />
                {user?.role !== RolesEnum.SUPERADMIN && !localStorage.getItem('originalToken') && (
                <AppTour />
                )}
                
                {/* Setup Todo - Yeni kullanıcılar için kurulum rehberi */}
                {user?.role !== RolesEnum.SUPERADMIN && !localStorage.getItem('originalToken') && (
                <SetupTodo />
                )}
              </div>
            </>
          )}
        </>

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
